import React from "react";
import { Col, Container, Row } from "reactstrap";

const Features = ({ features }) => {
  return (
    <section className='features-bg mb-0'>
      <Container className='m-width'>
        <Row>
          <Col md={12}>
            <Col md={12} className='text-center'>
              <div className='section-title mb-2'>
                <h2>Features of chatloop</h2>
                <img src='assets/images/title-line.png' alt='title-line' className='img-fluid' />
              </div>
            </Col>
            <div className='border-shape'></div>
            <div className='mt-50'>
              <ul className='features m-0 p-0 fadeIn-features'>
                {features.map((link, i) => (
                  <li key={i}>
                    <div className='features-img'>
                      <img src={link.imgUrl} className='img-fluid' alt={link.label} />
                      <h3 className='features-title'>{link.label}</h3>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Features;
